<div *ngIf="!hidden" class="is-relative">
    <isav-note-form [(value)]="note">
        <button isavBtn color="danger" type="button" (click)="hide()">Cancel</button>
        <button data-testid="btn-add" type="button" isavBtn color="success" (click)="add()">
            Add
        </button>
    </isav-note-form>
    <isav-loader-overlay *ngIf="loading"></isav-loader-overlay>
</div>
